import styles from './SizeInput.module.css'
import CustomNumber from '../../../../../../../components/CustomNumber/CustomNumber'

function SizeInput({ name, value, onChange }) {
  console.log('SizeInput VALUE', value)
  return (
    <div className={styles.container}>
      <CustomNumber
        name={name}
        value={value}
        onChange={onChange}
        min={0}
        step={1}
      />
    </div>
  )
}

export default SizeInput
